import styled from 'styled-components';

import { mediaWide } from '@xing-com/layout-tokens';
import {
  spaceXS,
  spaceS,
  xdlColorDimming,
  xdlColorTextOnDark,
  xdlPaletteMint11,
} from '@xing-com/tokens';

export const BubbleContainer = styled.div<{ $isPremium?: boolean }>`
  width: 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: flex-start;
  padding: ${spaceXS} ${spaceS};
  background: ${({ $isPremium }) =>
    $isPremium ? xdlPaletteMint11 : xdlColorDimming};

  p {
    color: ${xdlColorTextOnDark};
  }

  @media ${mediaWide} {
    width: 90px;
  }
`;
